import { PrasLoader, PrimeReactModal } from "@finanedi.es/storybook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { DefaultTFuncReturn } from "i18next"

interface ModalLoadingProps {
  isOpen: boolean
  title?: string | DefaultTFuncReturn
}

export const ModalLoading = ({
  isOpen = false,
  title = "Cargando...",
}: ModalLoadingProps) => {
  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-112 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-center'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-mb-1'>
            {title}
          </p>
        </div>
      }
      footer={
        <div className='tw-w-full [&>*:first-child]:tw-w-full tw-px-4'>
          <PrasLoader />
        </div>
      }
    />
  )
}
